import http from './http'
import Resource from './resource'

const path = 'admin/langs'

class Langs extends Resource {
  constructor(_http) {
    super(path, _http)
  }

  select(opt = {}) {
    return this.http.get(`api/${path}/select/list`, opt)
  }
}

const LangsRequest = new Langs(http)

export default LangsRequest
